import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Box,
  Flex,
  HStack,
  Link,
  Image,
  Text
} from '@chakra-ui/react';
import { SettingsIcon } from '@chakra-ui/icons';
import { useRecoilState } from 'recoil';
import { userAtom } from '../../state/userAtom';
import { logout } from '../../api/auth';

export const Header = () => {
  const [user, setUser] = useRecoilState(userAtom);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setUser(null);
    navigate('/');
  };

  return (
    <Box bg="brand.ltRed" color="brand.white" px={{ base: 4, md: 6 }} h="77px" display="flex" alignItems="center">
      <Flex align="center" justify="space-between" maxW="1400px" mx="auto" w="100%">
        <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
          <Image
            src="/img/IADC_Logo_H_Reverse_TM@2x.png"
            alt="IADC"
            h="32px"
          />
        </Link>

        {user && (
          <HStack spacing={6}>
            {(user.role === 'admin' || user.role === 'editor') && (
              <Link
                as={RouterLink}
                to="/admin"
                fontSize="16px"
                fontWeight="600"
                _hover={{ opacity: 0.8 }}
              >
                <HStack spacing={2}>
                  <SettingsIcon boxSize={4} />
                  <span>Admin</span>
                </HStack>
              </Link>
            )}
            <Text
              fontSize="16px"
              fontWeight="600"
              cursor="pointer"
              _hover={{ opacity: 0.8 }}
              onClick={handleLogout}
            >
              Logout
            </Text>
          </HStack>
        )}
      </Flex>
    </Box>
  );
};
